// extracted by mini-css-extract-plugin
module.exports = {"issue-slider":"CarrouselIssue_issue-slider___VFei"};